import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  withCredentials: true,
});

// ---------------------------------------------------------------------------
// Office Time (Owner)
// ---------------------------------------------------------------------------

export const getOfficeTime = async () => {
  const res = await axiosInstance.get("/office-time");
  return res.data;
};

export const upsertOfficeTime = async (data) => {
  const res = await axiosInstance.post("/office-time", data);
  return res.data;
};

// ---------------------------------------------------------------------------
// Staff Attendance (Owner)
// ---------------------------------------------------------------------------

export const getAllStaffAttendance = async (filters = {}) => {
  const res = await axiosInstance.get("/staff-attendance/all", { params: filters });
  return res.data;
};

export const adminMarkAttendanceOwner = async (data) => {
  const res = await axiosInstance.post("/staff-attendance/mark", data);
  return res.data;
};
